import React from 'react'
import GeotileTileEditor from './GeotileTileEditor'
import GeotileInfoEditor from './GeotileInfoEditor'

function createEditor( { geotile, props, type } ) {
  if ( geotile == null ) {
    return null
  }
  props = props || {}
  if ( type === 'tile' ) {
    return <GeotileTileEditor {...props} /> 
  }
  return <GeotileInfoEditor {...props} />
}

module.exports = {
  createEditor
}
